<script lang="ts">
  import { cva } from 'class-variance-authority';

  import Icon from './icon/icon.svelte';

  import { cn } from '$lib/utils';

  import type { IconOptions } from './icon/icon.svelte';

  const link = cva(
    [
      `
      appearance-none
      outline-none
      border-none
      cursor-pointer

      inline-flex
      items-center

      text-primary

      focus-visible:ring

      hover:text-primary/80

      rounded-micro

      transition
      motion-reduce:transition-none

      disabled:opacity-40
      disabled:pointer-events-none
      `
    ],
    {
      variants: {
        underline: {
          true: 'underline',
          false: ''
        }
      }
    }
  );

  let className: string | undefined = undefined;
  export { className as class };

  export let as: 'a' | 'button' = 'a';
  export let underline: boolean | undefined = undefined;
  export let leftIcon: IconOptions | undefined = undefined;
  export let rightIcon: IconOptions | undefined = undefined;
  export let href: string | undefined = undefined;
</script>

<!-- eslint-disable-next-line svelte/valid-compile -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<svelte:element
  this={as}
  on:click
  on:mouseenter
  on:mouseleave
  on:keydown
  on:keyup
  on:keypress
  on:focus
  on:blur
  on:pointerenter
  on:pointerleave
  on:touchstart
  on:touchend
  {href}
  class={cn(link({ underline }), className)}
  {...$$restProps}
>
  {#if leftIcon}
    <Icon icon={leftIcon} size="md" class="mr-1" />
  {/if}
  {#if $$slots.default}
    <slot />
  {/if}
  {#if rightIcon}
    <Icon icon={rightIcon} size="md" class="ml-1" />
  {/if}
</svelte:element>
